import { nullSafeGet, nullSafeGetOrElse } from './DataAccessUtils';

export const getMultipleChoiseWithLabelForExport = (multipleChoicesWithLabel) =>
	multipleChoicesWithLabel
		.map((choice) => `${choice.value}${choice.description ? `:${choice.description}` : ''}`)
		.join(',');

export const getMultipleChoiseWithLabelForBE = (stringValue = '') =>
	stringValue.split(',').map((choice) => {
		const valueAndDescription = choice.split(':');
		return {
			value: valueAndDescription[0],
			...(nullSafeGet('1', valueAndDescription) && {
				description: valueAndDescription[1],
			}),
		};
	});

export const validateForDuplicateTitlesUnderSameGroup = (records) => {
	const { duplicateTitles } = records.reduce(
		(acc, record) => {
			const { uniqueKeys, duplicateTitles } = acc;
			const key = `${nullSafeGetOrElse('groupTitle', record, '')}-${nullSafeGetOrElse(
				'title',
				record,
				''
			)}`;
			return {
				...acc,
				...(uniqueKeys.includes(key)
					? {
							duplicateTitles: [...duplicateTitles, record.title],
					  }
					: {
							uniqueKeys: [...uniqueKeys, key],
					  }),
			};
		},
		{ uniqueKeys: [], duplicateTitles: [] }
	);

	return duplicateTitles.length > 0
		? (duplicateTitles.length > 1
				? `Titles ${duplicateTitles
						.map((_) => `"${_}"`)
						.join(', ')} are repeated under same group. `
				: `Title "${duplicateTitles[0]}" is repeated under same group. `) +
				'Please fix it or remove the duplicate to proceed'
		: '';
};
